import React, {useMemo} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import {ROUTES} from "../../../../routes";


const GroheCartStepper = (props) => {

  const {history, location, fabricatorSettings, isPhoneNumberValidated} = props;

  const allSteps = useMemo(() => {
    return [{
      translateId: "grohe.cart.stepper.information",
      isVisible: true,
      isDisabled: false,
      url: ROUTES.cartLogin,
    }, {
      translateId: "grohe.cart.stepper.billing",
      isVisible: fabricatorSettings.hasPaymentGateway,
      isDisabled: !isPhoneNumberValidated,
      url: ROUTES.cartBilling,
    }, {
      translateId: "grohe.cart.stepper.confirm",
      isVisible: true,
      isDisabled: !isPhoneNumberValidated,
      url: ROUTES.cartConfirm,
    }, {
      translateId: "grohe.cart.stepper.shipping",
      isVisible: fabricatorSettings.useShipping,
      isDisabled: !isPhoneNumberValidated,
      url: ROUTES.cartDelivery,
    }];
  }, [fabricatorSettings, isPhoneNumberValidated])

  const setStep = (step) => {
    if (step.isDisabled) {
      return false
    }
    history.push(step.url);
  }

  return (
    <div className="gc-stepper">
      <ul className="gc-stepper__list">
        {allSteps.map(step => {
          if (!step.isVisible) {
            return null
          }
          const isActive = step.url === ROUTES.cartLogin
            ? location.pathname === ROUTES.cartLogin || location.pathname === ROUTES.cartRegister
            : location.pathname === step.url;
          return (
            <li className={"gc-stepper__list-item" + (isActive ? " gc-stepper__list-item--active" : "")
              + (step.isDisabled ? " gc-stepper__list-item--disabled" : "")}
                key={step.translateId}
                onClick={() => setStep(step)}>
              <FormattedMessage id={step.translateId}/>
            </li>
          )
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {settings} = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState;

  return {
    isMobile,
    isPhoneNumberValidated,
    fabricatorSettings: settings
  };
};

const mapDispatchToProps = {
  // setLookPageOpened,
  // setLookOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartStepper)
)
